export enum CloudProvider {
  AWS = 'aws',
  AZURE = 'azure',
  GCP = 'gcp',
  OCI = 'oci',
}

export enum Tool {
  TERRAFORM = 'terraform',
  TERRAGRUNT = 'terragrunt',
  OPENTOFU = 'opentofu',
}

export interface VariableDefinition {
  name: string;
  type: string;
  description?: string;
  default?: string | number | boolean | null;
  required: boolean;
}

export interface Override {
  id: string;
  name: string;
  value: string;
}

export interface GeneratedFiles {
  provider: string;
  main: string;
  overrides: string;
}

export interface ValidationResult {
  isValid: boolean;
  issues: string[];
  summary: string;
  formattingIssues?: FormattingIssue[];
  hasFormattingIssues?: boolean;
}

export interface FormattingIssue {
  file: 'provider' | 'main' | 'overrides';
  line: number;
  issue: string;
  suggestion?: string;
}

export interface AppState {
  tool: Tool;
  provider: CloudProvider;
  region: string;
  gcpProjectId: string;
  moduleUrl: string;
  variables: VariableDefinition[];
  stagedOverrides: Override[];
  generatedFiles: GeneratedFiles | null;
  validationResult: ValidationResult | null;
  isLoading: boolean;
  isValidating: boolean;
  loadingMessage: string;
  error: string | null;
}

export const INITIAL_STATE: AppState = {
  tool: Tool.TERRAFORM,
  provider: CloudProvider.AWS,
  region: '',
  gcpProjectId: '',
  moduleUrl: '',
  variables: [],
  stagedOverrides: [],
  generatedFiles: null,
  validationResult: null,
  isLoading: false,
  isValidating: false,
  loadingMessage: '',
  error: null,
};
